import { createTheme } from './baseTheme.esm.js';
import '../base/pageTheme.esm.js';
import { palettes } from '../base/palettes.esm.js';

const lightTheme = createTheme({
  palette: palettes.light
});
const darkTheme = createTheme({
  palette: palettes.dark
});

export { darkTheme, lightTheme };
//# sourceMappingURL=themes.esm.js.map
